module.exports = __webpack_public_path__ + "img/frame (195).9c6ddd04.jpg";